<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>
          <!-- 选择车牌按钮 -->
          <VehicleSelect :modalList="cars" @onChecked="onChecked">
            <template #start>
              <div class="sinput">
                <SearchField :form="sform" :formCtrl="sformCtrl" @onSearch="onSearch" @onReset="onModalReset"
                  @onChange="onSearchItemChange" />
              </div>
            </template>
          </VehicleSelect>
          <!-- 其他控件 -->
          <FormItem v-for="(c, i) in formCtrl" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>

          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 3)" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <div v-show="form.pricing_id != 5">
            <FormItem v-for="(c, i) in formCtrlOrder.slice(3)" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="c.viewMode"
              :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

            <!-- 亏吨重量控件 -->
            <span>
              <FormItem v-show="form.pricing_id == 1" :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl"
                :options="kuitonCtrl.options" :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
            </span>
          </div>

          <div>
            <FormItem v-for="(c, i) in formCtrlOrder2" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>
          <!-- 重量控件 -->
          <span v-show="form.pricing_id == 1">
            <FormItem v-for="(c, i) in formCtrlWeight" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </span>
        </div>

        <div class="block">
          <div class="contit">备注信息</div>
          <FormItem v-for="(c, i) in formCtrlTime" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 结款提醒组件 -->
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="`formItem${i}_${c.keyName}_${!!c.disabled}`" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <!-- 附加费用 -->
        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";
import hireMixin from "../hireMixin";

export default {
  mixins: [detailMixin, orderViewMixin, hireMixin],
  data() {
    return {
      breadcrumb: [
        { name: "运单管理", path: "/order/nocontract" },
        { name: "普通运单", path: "/order/nocontract/hire" },
        { name: "普通外协运单添加" },
      ],
      formCtrl: [
        // {
        //   label: "承运公司",
        //   keyName: "pcustomname",
        //   err: "请填写承运公司",
        //   type: "text",
        //   viewMode: true,
        // },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请选择客户名称",
          type: "select",
          options: [],
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请选择货物名称",
          type: "select",
          options: [],
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          //className: "unton",
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
      custom: [],
    };
  },
  methods: {
    setDetail() {
      console.log('再派一单')

      const keys = [
        'shipperid',
        'name',
        // 'shname',
        'nid',
        'pricing_id',
        'pricing_name',
        'cprice',
        'dprice',
        'coaddress',
        'enaddress',
      ]
      keys.map(k => {
        this.$set(this.form, k, this.detail[k])
      })
      // 如果options先到则在这里匹配
      this.setPricingName()

      this.setCustom()

      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },
    
    setCustom() {
      // 再派一单获取detail，取出shipperid
      let { shipperid, shname } = this.detail
      // console.log(shipperid, shname)
      // 如果是报单派单，不获取detail，通过c_id获取详情信息
      if (this.c_id) {
        shipperid = this.c_id
      }
      if (this.custom && this.custom.length) {
        this.custom.map(v => {
          // 匹配shipperid，设置合成用户名
          if (v.id == shipperid) {
            this.$set(this.form, 'shname', v.name + '-' + v.member)
            this.$forceUpdate()
            // console.log('form', { ...this.form })
          }
        })

        if (shipperid && !this.form.shname) {
          this.$set(this.form, 'shname', shname)
        }
      }

    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.choose {
        display: flex;

        .el-form-item__content {
          flex: 1;
        }
      }

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

/deep/ .sinput {
  .fillet {
    padding: 0;
    box-shadow: none;
  }

  .retrieval {
    margin: 0;

    .el-form-item__content {
      .el-input {
        width: 150px !important;
      }
    }

    .el-form {
      margin-bottom: 0px !important;
    }

    .el-form-item {
      margin: 0 0 10px 0;
    }
  }



}
</style>
